module.exports = __webpack_public_path__ + "static/media/image_2.9d6ef41c.png";